import DataTable from 'react-data-table-component';
import ButtonLink from "../../generico/ButtonLink";
import ConfigService from "../../../services/configuracion/ConfigService";
import history from "../login/history";
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const paginationOptions = {
    rangeSeparatorText: "de",
    rowsPerPageText: 'Filas por página',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos'
};

const TRASLADO_CUOTAS = 364;

export const ModificacionFechaVencPrestamo = (props) =>{

    const modificarCuota = (url,param) => {
        sessionStorage.setItem('prestamo',param);
        history.push(url,{param});
        window.location.reload();
    }

    const getColumn = () =>{
        return [
            {
                name: "Cuenta",
                selector: row => row.cuenta,
                center : true
            },
            {
                name: "Tipo",
                selector: row => row.descripcion,
                center : true
            },
            {
                name: "Moneda",
                selector: row => row.moneda,
                center : true
            },
            {
                name: "Desembolso",
                selector: row => row.inicio,
                center : true
            },
            {
                name: "Monto del Préstamo",
                selector: row => row.capital,
                center : true
            },
            {
                name: "Cuota",
                selector: row => row.cuotasPagadas,
                center : true
            },
            {
                name: "Vencimiento",
                selector: row => row.fechaVencimiento,
                center : true
            },
            {
                name: "Último Pago",
                selector: row => row.ultimoPago,
                center : true
            },
            {
                cell: (row) => (
                    // <>
                        <ButtonLink
                            className="btn btn-cu-terciary btn-lg btn-block"
                            param={row}
                            url={ConfigService.getPathByName("modificacionFechaVencimiento")?.url}
                            onClick={modificarCuota}
                        >
                            <FontAwesomeIcon icon={faMoneyBill} />  Trasladar Cuota
                        </ButtonLink>
                    // </>
                ),
                center : true
            },
        ];
    }

    return (
        <DataTable
            noHeader={true}
            columns={ getColumn() }
            data={props.detalles}
            responsive={true}
            pointerOnHover
            pagination={false}
            paginationComponentOptions={paginationOptions}
            noDataComponent="no hay registros para mostrar"
            striped={true}
            progressPending={false}
        />
    )
    
    
}

